import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from '@global/constants'

export const ButtonContainer = styled.div`
  position: relative;
`

export const FileTypeGroup = styled.div`
  padding: 24px 0 0 0;
`

export const autocomplete = css``

export const buttonProgress = css`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
`

export const content = css`
  width: 485px;
  min-width: 485px;
  padding: 0 24px 16px 24px;
`

export const formControl = css`
  padding-top: 8px;
`

export const formLabel = css`
  font-size: 1rem;
  color: ${colors.black};
`

export const dialogTitle = css`
  padding: 16px 24px 0px 24px;
`

export const title = css`
  font-size: 20px;
`
